import Link from './Link.view';

export default Link;
